// imporErt PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './DiamondcertificateIcon.style';

export class DiamondcertificateIcon extends PureComponent {
    static propTypes = {
        // TODO: implement prop-types
    };

    render() {
        return (
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_2570_16225" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
                    <rect x="0.518555" y="0.40625" width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_2570_16225)">
                    <path d="M10.3186 13.8948L11.1456 11.1792L8.97055 9.5025H11.6763L12.5186 6.7985L13.3608 9.5025H16.0666L13.8763 11.1792L14.7031 13.8948L12.5186 12.2063L10.3186 13.8948ZM7.01855 22.637V15.4793C6.38522 14.8178 5.89355 14.053 5.54355 13.185C5.19355 12.3172 5.01855 11.3909 5.01855 10.4062C5.01855 8.31392 5.74547 6.54083 7.19931 5.087C8.65314 3.63317 10.4262 2.90625 12.5186 2.90625C14.6109 2.90625 16.384 3.63317 17.8378 5.087C19.2916 6.54083 20.0186 8.31392 20.0186 10.4062C20.0186 11.3909 19.8436 12.3172 19.4936 13.185C19.1436 14.053 18.6519 14.8178 18.0186 15.4793V22.637L12.5186 20.887L7.01855 22.637ZM12.5186 16.4062C14.1852 16.4062 15.6019 15.8229 16.7686 14.6562C17.9352 13.4896 18.5186 12.0729 18.5186 10.4062C18.5186 8.73958 17.9352 7.32292 16.7686 6.15625C15.6019 4.98958 14.1852 4.40625 12.5186 4.40625C10.8519 4.40625 9.43522 4.98958 8.26855 6.15625C7.10189 7.32292 6.51855 8.73958 6.51855 10.4062C6.51855 12.0729 7.10189 13.4896 8.26855 14.6562C9.43522 15.8229 10.8519 16.4062 12.5186 16.4062ZM8.51855 20.4408L12.5186 19.3678L16.5186 20.4408V16.7255C15.9481 17.0973 15.3237 17.3871 14.6456 17.5948C13.9672 17.8024 13.2582 17.9062 12.5186 17.9062C11.7789 17.9062 11.0699 17.8024 10.3916 17.5948C9.71339 17.3871 9.08905 17.0973 8.51855 16.7255V20.4408Z" fill="#8EBF38" />
                </g>
            </svg>
        );
    }
}

export default DiamondcertificateIcon;
